export default __webpack_public_path__ + "static/media/eden-ben-zaken_haim-sheli.852db2cb.mp3";